module.exports = __webpack_public_path__ + "163e7149d1695f9f9761c2365bda32ae.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/spacemarines-vignette-preview-460.webp
// module id = 549
// module chunks = 0